import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M16,2A7,7,0,0,0,9,9.07V10.5A9,9,0,0,0,12,17c-5.78.86-10,3.83-10,7v4a2,2,0,0,0,2,2H19a.5.5,0,0,0,.39-.81,7,7,0,0,1,2.87-10.64.5.5,0,0,0,0-.92A11.66,11.66,0,0,0,20,17a9.08,9.08,0,0,0,3-6.5V9.07h0A7,7,0,0,0,16,2Z"/><path d="M29,24H26V21a1,1,0,0,0-2,0v3H21a1,1,0,0,0,0,2h3v3a1,1,0,0,0,2,0V26h3a1,1,0,0,0,0-2Z"/>';
export var NewTeamMemberSVG = function NewTeamMemberSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
NewTeamMemberSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(NewTeamMemberSVG);